import { render, staticRenderFns } from "./PendingIdentityValidation.vue?vue&type=template&id=35648d39&scoped=true"
import script from "./PendingIdentityValidation.vue?vue&type=script&lang=js"
export * from "./PendingIdentityValidation.vue?vue&type=script&lang=js"
import style0 from "./PendingIdentityValidation.vue?vue&type=style&index=0&id=35648d39&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35648d39",
  null
  
)

export default component.exports